module.exports = __webpack_public_path__ + "static/media/route-pro-badge-lg.aa20182b.svg";